import AllWebsitesSelectionItem from "../../../../company-search/models/table-actions-panel/AllWebsitesSelectionItem";
import type { SelectionDropdownItem } from "../../../../table-actions-panel/models/selection-dropdown-item/types";

const removeFromListSelectionDropdown = {
    getItems(numberOfResults: number): readonly SelectionDropdownItem[] {
        if (numberOfResults > 0) {
            return [new AllWebsitesSelectionItem(numberOfResults)];
        }

        return [];
    },
};

export default removeFromListSelectionDropdown;
